<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-home"
            v-if="isAccountLoaded">
            <nav-bar-logo
                class="history-nav"
                :userType="userType"
                :isShowCart="true"
                :namePage="trackingCate"></nav-bar-logo>
            <tab-bar
                :lblTab="lbl.tabbar"
                :theme="userType"
                tabActive="home"></tab-bar>
            <div class="wrapper-page-home">
                <div class="profile">
                    <div class="img-profile">
                        <img class="img-fluid" :src="getPictureLine()" v-if="isLine">
                        <img class="img-fluid" src="../../../assets/other/pic_profile.png" v-if="!isLine" />
                    </div>
                    <div class="info-profile">
                        <div class="user_name">คุณ {{`${profile.strFirstName} ${profile.strLastName}`}}</div>
                        <div class="user_point">มี <span class="points">{{pointFormat()}}</span> คะแนน</div>
                    </div>
                    <!-- <div class="info-profile">
                        <div class="user_name">คุณ{{`${profile.strFirstName} ${profile.strLastName}`}}</div>
                        <div class="user_point theme-txt">มี {{pointFormat()}} คะแนน</div>
                        <div class="point-info">
                            <div class="point-info-txt">อัพเดทล่าสุด {{formatDate(pointDate)}}</div>
                            <div class="point-info-txt">คะแนนจะอัพเดทภายใน 3-7 วันทำการ</div>
                        </div>
                    </div> -->
                </div>

                <div class="home-dashboard">
                    <DashboardSlider
                        listName="dashboard"
                        :apiConfig="dashboardConfig"
                        :controller="modalController"
                        @apiLoaded="apiLoaded($event)">
                    </DashboardSlider>
                </div>

                <ProductSection
                    :listProductConfig="listProductConfig"
                    :modalController="modalController"
                    @apiLoaded="apiLoaded($event)" />

                <PrivilegeSection
                    :listPrivilegeConfig="listPrivilegeConfig"
                    :modalController="modalController"
                    @apiLoaded="apiLoaded($event)" />

                <MarketPlaceSection
                    :listMarketPlaceConfig="listMarketPlaceConfig"
                    :modalController="modalController"
                    @apiLoaded="apiLoaded($event)" />

            </div>
        </div>
        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>

<script>
import Vue from 'vue';
import Moment from 'moment';
//import Carousel from 'vue-owl-carousel'; // https://github.com/s950329/vue-owl-carousel
import Util from "@/helper/Utility.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//component
import NavBarLogo from "@/components/Layout/NavBar/NavBarLogo.vue";
import TabBar from "@/components/Layout/TabBar/TabBar.vue";
import DashboardSlider from "@/components/Dashboard/DashboardSlider.vue";
import PrivilegeSection from "../component/Privilege/PrivilegeSection.vue";
import ProductSection from "../component/Product/ProductSection.vue";
import MarketPlaceSection from '../component/MarketPlace/MarketPlaceSection.vue';
//core
//import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
// import Account from '@/helper/AccountHelper.js';
//campaign
import {
    CampaignListConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";

export default {
    name: "home",
    mixins: [
        AccountMixin,
        LocaleMixin,
        ErrorApiMixin
    ],
    components: {
        NavBarLogo,
        TabBar,
        ModalMaster,
        DashboardSlider,
        PrivilegeSection,
        ProductSection,
        MarketPlaceSection,
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            //loading
            isLoading: false,
            isPrivilegeLoaded: false,
            isProductLoaded: false,
            isMarkerPlaceLoaded: false,
            isExpireLoaded: false,
            isDashboardLoaded: false,
            //expire
            expiringPoint: 0,
            expiringTime: 0,
            //error handler
            errorHandler: null,
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            confirmModal: new ConfirmModalController(),
            loadingModal: new LoadingModalController(),
            //dashboard
            dashboardConfig: Vue.bzbsConfig.mainConfig.main_dashboard,
            //product
            listProductConfig: {},
            listPrivilegeConfig: {},
            listMarketPlaceConfig: {},

            trackingService: new TrackingService(this),
            trackingScreenName: 'privilagelist',
            trackingCate: 'privilagelist_page',
        };
    },
    created: function() {
        this.getExpiringPoint();
        this.initialProductConfig();
        this.initialPrivilegeConfig();
        this.initialMarketPlaceConfig();
        // this.checkCookieAccept();
        //modal setup
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);
        //error
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        this.trackingService.screenName(this.trackingScreenName);
        this.trackingService.event(this.trackingCate, 'view_privilagelist_page', null, null)
    },
    mounted: function () {
        this.showLoading();
    },
    methods: {
        //method
        initialProductConfig: function() {
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.home_product)
                .setTop(5)
                .create();
            this.listProductConfig = listConfig;
        },
        initialPrivilegeConfig: function() {
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.privilege)
                .setTop(2)
                .create();
            this.listPrivilegeConfig = listConfig;
        },
        initialMarketPlaceConfig: function () {
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.marketplace)
                .setTop(5)
                .create();
            this.listMarketPlaceConfig = listConfig;
        },
        getExpiringPoint: function () {
            var token = this.getToken();
            BzbsProfile.apiGetExpiringPoint(token)
                .then(res => {
                    this.expiringPoint = res.data.expiring_points.points;
                    this.expiringTime = res.data.expiring_points.time;

                    this.apiLoaded({type: 'expire'});
                }).catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        //Util
        formatDate: function (time) {
            if (!time) return;
            var expiringPointTime = time;

            var result = Moment.unix(expiringPointTime).utc();
            var year = Moment.unix(expiringPointTime).utc().format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = result.format('MM');
            var day = result.format('DD');

            var date = `${day}/${month}/${year}`;
            //var monthString = this.lblDate.month_short[result.format('M') - 1];

            return date;
        },
        pointFormat: function () {
            var point = Util.formatNum(this.point);
            return point;
        },
        //event
        clickToPage: function(page){
            if (this.$route.path !== page) this.$router.push("/" +page);
        },
        //loading
        apiLoaded: function (data) {
            switch(data.type) {
                case "dashboard":
                    this.isDashboardLoaded = true;
                    break;
                case "privilege":
                    this.isPrivilegeLoaded = true;
                    break;
                case "product":
                    this.isProductLoaded = true;
                    break;
                case "marketplace":
                    this.isMarkerPlaceLoaded = true;
                    break;
                case "expire":
                    this.isExpireLoaded = true;
                    break;
            }

            if (this.isDashboardLoaded
                && this.isPrivilegeLoaded
                && this.isProductLoaded
                && this.isMarkerPlaceLoaded
                && this.isExpireLoaded)
                this.hideLoading();
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.loadingModal.hide();
        },
    },
};
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    @import "Home.scss";
</style>
<style lang="scss">
.home-dashboard{
    margin-top: 20px;

    .dashboard-slider{
        position: relative;
        width: 100%;

        img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 10px;
        }

        &:before {
            position: relative;
            content: "";
            display: block;
            padding-top: 50%;
        }
    }

    .owl-theme .owl-nav.disabled + .owl-dots{
        position: relative;
        margin-top: -25px ;

        button{
            outline: none;
        }
        .owl-dot span{
            width: 8px;
            height: 8px;
            margin: 5px 4px;
            background: rgba(255,255,255, 0.8)
        }

        .owl-dot.active span, .owl-dot:hover span{
            width: 10px;
            height: 10px;
            background: #fff;
        }
    }

}
</style>
